<template>
  <div v-if="loadingShow">
    <div class="container">
      <div class="card">
        <!-- <div class="title" style="margin-left:10px">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-putcontract"></use>
          </svg>
          <span>
              {{ customer.custName }}
              <van-tag round type="primary" v-if="customer.contractStatus == 1">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
              <van-tag round type="success" v-if="customer.contractStatus == 2">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
              <van-tag round type="danger" v-if="customer.contractStatus == 3">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
              <van-tag round type="warning" v-if="customer.contractStatus == 4">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
          </span>
          <van-icon v-if="!activeName" name="edit" color="#f8df0d" size="20px" class="icon-edit" v-hasPermi="['cont:newContract:edit']" @click="edit"/>
          <van-icon v-if="!activeName" name="delete" color="red" size="20px" class="icon-delete" v-hasPermi="['cont:newContract:remove']" @click="remove" />
        </div> -->
        <div class="title">
          <!-- <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg> -->
          <van-image width="30" height="32px" :src="contractImg" />
          <span style="flex: 1">{{customer.custName}}</span>
          <van-tag round :type="customer.contractStatus==4?'danger':'success'">{{ formatHandel('contractStatus',customer.contractStatus) }}</van-tag>
        </div>
        <div class="title">
          <div style="font-size: 15px;margin-left: 36px; flex: 1">
            <span v-if="customer.contractNum">{{ customer.contractNum }}</span>
            <span v-else>ID：{{ customer.contractId }}</span>
          </div>
          <van-tag v-if="customer.contractStatus === 7" round :type="typeArr[customer.executionStatus]">{{ formatHandel('executionStatus',customer.executionStatus) }}</van-tag>
        </div>
        <!-- <div class="title_des">【{{customer.businessTypeName}}】</div> -->
        <!-- <div class="approval-status" v-if="(activeName == 1 || activeName == 2) && customer.contractStatus != 9 && customer.contractStatus != 30">
          <span class="detail_span">审批状态：待{{customer.spLabelStatus}}审批</span>
          <van-button size="mini" type="info" @click="viewStatus">详情</van-button>
        </div>
        <div class="approval-status" v-if="activeName && activeName != 1 && activeName != 2 && customer.spNo">
          <span>审批详情：{{customer.spLabelStatus}}</span>
          <van-button size="mini" type="info" @click="viewStatus">详情</van-button>
        </div>
        <div class="approval-status" v-if="!activeName && customer.contractStatus == 4">
          <span>审批状态：驳回</span>
          <van-button size="mini" type="info" @click="viewStatus">详情</van-button>
        </div> -->
        <van-tabs v-model="active" @click="tabClick">
          <van-tab title="基本信息">
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '10px 0 0px 0' }">签约</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">业务类型：</span>
                <span class="value">{{ customer.businessTypeName }}</span>
              </div>
              <div class="item">
                <span class="key">签约主体：</span>
                <span class="value">{{customer.companyName || '-'}}</span>
              </div>
              <div class="item" >
                <span class="key">执行时间：</span>
                <span class="value">{{ customer.startTime }}至{{customer.endTime}}</span>
              </div>
              <div class="item">
                <span class="key">签约日期：</span>
                <span class="value">{{customer.signTime || '-'}}</span>
              </div>
            </div>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '10px 0 0px 0' }">金额</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item">
                <span class="key">合同金额(元)：</span>
                <span class="value">{{ customer.contractMoney }}<span class="bigMoney">大写：{{toChineseBig(customer.contractMoney)}}</span></span>
              </div>
              <div class="item">
                <span class="key">回款金额(元)：</span>
                <span class="value">{{ customer.allReturnedMoney }}<span v-if="customer.allReturnedMoney || customer.allReturnedMoney != 0" class="bigMoney">大写：{{toChineseBig(customer.allReturnedMoney)}}</span></span>
              </div>
            </div>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '10px 0 0px 0' }" v-if="customer.advancesMoney">授信</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item">
                <span class="key">授信总额：</span>
                <span class="value">{{ customer.advancesMoney }}<span v-if="customer.advancesMoney != 0" class="bigMoney">大写：{{toChineseBig(customer.advancesMoney)}}</span></span>
              </div>
              <div v-if="customer.creditCycleValue" class="gd_box">
                <div class="item" >
                  <span class="key">授信账期类型：</span>
                  <span class="value">{{formatHandel('creditCycleType',customer.creditCycleType)}}</span>
                </div>
                <div class="item" >
                  <span class="key">授信账期时间：</span>
                  <span class="value">{{ customer.creditCycleValue }}(天)</span>
                </div>
              </div>
            </div>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '10px 0 0px 0' }" v-if="customer.contractStatus == 7">垫款</van-divider>
            <div class="list-wrap van-hairline--top" v-if="customer.contractStatus == 7">
              <div class="item">
                <span class="key">累计垫款(元)：</span>
                <span class="value">{{ customer.creditTotalMoney }}<span v-if="customer.creditTotalMoney != 0" class="bigMoney">大写：{{toChineseBig(customer.creditTotalMoney)}}</span></span>
              </div>
              <div class="item" v-if="customer.inMoney">
                <span class="key">累计垫款回款(元)：</span>
                <span class="value">{{ customer.inMoney }}<span v-if="customer.inMoney != 0" class="bigMoney">大写：{{toChineseBig(customer.inMoney)}}</span></span>
              </div>
              <div class="item" v-if="customer.notMoney">
                <span class="key">当前未回款(元)：</span>
                <span class="value">{{ customer.notMoney }}<span v-if="customer.notMoney != 0" class="bigMoney">大写：{{toChineseBig(customer.notMoney)}}</span></span>
              </div>
              <!-- <div class="item" v-if="customer.advancesCycle">
                <span class="key">垫款事由：</span>
                <span class="value">{{ customer.advancesCycle }}</span>
              </div> -->
            </div>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '10px 0 0px 0' }">其他</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" style="width: 52%">
                <span class="key">发票类型：</span>
                <span class="value">{{formatHandel('invoiceType',customer.invoiceType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">开票方式：</span>
                <span class="value">{{formatHandel('invoicingMethod',customer.invoicingMethod)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">垫款方式：</span>
                <span class="value">{{formatHandel('payType',customer.payType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">框架类型：</span>
                <span class="value">{{formatHandel('frameType',customer.frameType)}}</span>
              </div>
              <div v-if="isVendite" class="gd_box">
                <div class="item" style="width: 48%">
                  <span class="key">媒介归属：</span>
                  <span class="value">{{formatHandel('mediaType',customer.mediaType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">运营方式：</span>
                  <span class="value">{{formatHandel('operationMode',customer.operationMode)}}</span>
                </div>
              </div>
              <div class="item" v-if="customer.contractStatus == 6">
                <span class="key">归档日期：</span>
                <span class="value">{{customer.filingDate || '-'}}</span>
              </div>
              <div class="item" >
                <span class="key">条款说明：</span>
                <span class="value">{{ customer.content || '-' }}</span>
              </div>
              <div class="item" >
                <span class="key">我方签约部门/人：</span>
                <span class="value">{{ customer.deptName }}<span style="margin-left: 5px;color: #1989fa">{{ customer.userName }}</span></span>
              </div>
              <div class="item" >
                <span class="key">创建时间：</span>
                <span class="value">{{ customer.createTime }}</span>
              </div>
            </div>
              <!-- <div class="item" style="width: 48%">
                <span class="key">合同模板：</span>
                <span class="value">{{formatHandel('templateType',customer.templateType)}}</span>
              </div> -->
          </van-tab>
          <van-tab title="合同日志">
            <div class="item">
              <!-- <van-list :finished="finished" finished-text="没有更多了"  @load="getContractLogList" v-if="contractLogList.length > 0">
                <van-cell-group v-for="(item,index) in contractLogList" :key="index">
                  <van-cell :title="item.remark" value="" :label="item.createTime" />
                </van-cell-group>
              </van-list>
              <empty v-if="contractLogList.length == 0" /> -->
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in contractLogList" :key="index">
                  <span style="font-weight: bold">{{item.remark}}</span>
                  <span style="margin-left: 8px">{{item.createTime}}</span>
                  <log-examine :logExamineArr="item.listData"> 0"></log-examine>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
          <van-tab title="签约信息">
            <div class="list-wrap van-hairline--top">
              <div style="width: 100%;padding-bottom: 10px;"><van-tag type="warning" size="large">对方信息</van-tag></div>
              <div class="item" style="width: 48%">
                <span class="key">签约人：</span>
                <span class="value">{{ customer.signedUser }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">电话：</span>
                <span class="value">{{ customer.signedUserMobile || '-' }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">邮箱：</span>
                <span class="value">{{ customer.signedUserEmail || '-' }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">微信：</span>
                <span class="value">{{ customer.signedUserWx || '-' }}</span>
              </div>
              <div style="width: 100%;padding-bottom: 10px;"><van-tag type="primary" size="large">我方信息</van-tag></div>
              <!-- <div class="item" >
                <div class="item" >
                <span class="key">我方签约主体地位：</span>
                <span class="value">{{formatHandel('signedMainType',customer.signedMainType)}}</span>
              </div> -->
              <div class="item" >
                <span class="key">主体机构：</span>
                <span class="value">{{customer.companyName}}<span v-if="customer.signedMainType">({{formatHandel('signedMainType',customer.signedMainType)}})</span></span>
              </div>
              <div class="item" >
                <span class="key">签约部门/人：</span>
                <span class="value">{{ customer.deptName }}<span style="margin-left: 5px;color: #1989fa">{{ customer.userName }}</span></span>
              </div>
              <!-- <div class="item" >
                <span class="key">我方签约人：</span>
                <span class="value">{{ customer.userName }}</span>
              </div> -->
              <div style="width: 100%;padding-bottom: 10px;"><van-tag type="success" size="large">信息提供</van-tag></div>
              <div class="item" >
                <span class="key">部门/人：</span>
                <span class="value">{{ customer.infoDeptName || '-' }}<span style="margin-left: 5px;color: #07c160">{{ customer.infoUserName }}</span></span>
              </div>
              <!-- <div class="item">
                <span class="key">信息提供部门：</span>
                <span class="value">{{ customer.infoDeptName}}</span>
              </div>
              <div class="item">
                <span class="key">信息提供人：</span>
                <span class="value">{{ customer.infoUserName}}</span>
              </div> -->
              <!-- <div class="item" v-if="customer.templateType == 2">
                <span class="key">申请用印日期：</span>
                <span class="value">{{ customer.useSealTime }}</span>
              </div> -->
              <!-- <div class="item" v-if="customer.templateType == 2 && customer.payType != 2">
                <span class="key">用印事由：</span>
                <span class="value">{{ customer.advancesCycle }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">交付日期：</span>
                <span class="value">{{ customer.deliveryTime }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">签约时间：</span>
                <span class="value">{{ customer.signTime }}</span>
              </div> -->
            </div>
          </van-tab>
          <van-tab title="合同项目" v-if="customer.businessTypeName.indexOf('效果运营类') > -1 || customer.businessTypeName.indexOf('数字媒介') > -1">
            <div class="list-wrap van-hairline--top">
              <div class="item" v-if="customer.mediaLocationNames">
                <span class="key">媒体版位：</span>
                <van-tag v-for="(item,index) in customer.mediaLocationNames.split(',')" :key="index" color="#1989fa">{{item}}</van-tag>
              </div>
              <div class="item" v-if="customer.deliveryLinkNames">
                <span class="key">投放链路：</span>
                <van-tag v-for="(item,index) in customer.deliveryLinkNames.split(',')" :key="index" color="#1989fa">{{item}}</van-tag>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">开户服务费：</span>
                <span class="value">{{ customer.openAccountFee || '-'}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">代运营服务费：</span>
                <span class="value">{{ customer.agentBussFee || '-'}}</span>
              </div>
            </div>
            <van-list :finished="finished" finished-text="没有更多了" v-if="projectList.length > 0" style="margin-top: 10px">
              <van-cell v-for="(item,index) in projectList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div>
                    <div style="padding-left:70px;text-indent:-70px;">
                      <span class="key"> 项目名称：</span>
                      <span class="value">{{`【${item.percentage}%/${item.calculationMethodStr}】${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}}</span>
                    </div>
                    <!-- <div>
                      <span class="key"> 返点百分比值(%)：</span>
                      <span class="value">{{ item.percentage }}%</span>
                    </div>
                    <div>
                      <span class="key"> 返点消耗(元)：</span>
                      <span class="value">{{ item.useMoney }}(元)</span>
                    </div>
                    <div>
                      <span class="key"> 执行时间：</span>
                      <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
                    </div> -->
                  </div>
                </div>
                <van-button style="margin: 10px auto; width: 30%" class="topBtn" round block type="warning" native-type="button" size="mini" @click="pointDetail(item)">返点信息</van-button>
              </van-cell>
            </van-list>
          </van-tab>
          <van-tab title="附件信息">
            <div class="item">
              <van-list :finished="finished" finished-text="没有更多了"  @load="getContractFileList" v-if="contractFileList.length > 0">
                <van-cell v-for="(item,index) in contractFileList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div style="max-width: 80%">
                      <!-- <div>
                        <span class="key"> 附件标题：</span>
                        <span class="value">{{ item.title }}</span>
                      </div> -->
                      <div>
                        <span class="key"> 附件类型：</span>
                        <span class="value">{{formatHandel('fileType',item.fileType)}}</span>
                      </div>
                      <div v-if="item.amount">
                        <span class="key"> 合同金额：</span>
                        <span class="value">{{ item.amount }}(元)</span>
                      </div>
                      <div v-if="item.fileDesc">
                        <span class="key"> 附件描述：</span>
                        <span class="value">{{ item.fileDesc }}</span>
                      </div>
                    </div>
                    <div style="display: flex;flex-direction:column;justify-content: space-around">
                      <a :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">附件详情</a>
                      <!-- <span v-if="activeName == 0" style="color: #ff976a" @click="modifyFile(item)">修改</span>
                      <span v-if="activeName == 0" style="color: #ee0a24" @click="deleteFile(item)">删除</span> -->
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="contractFileList.length == 0" />
              <!-- <div v-if="contractFileList.length == 0" style="background-color: #fff;text-align:center;color:red;height:50px;line-height:50px;">暂无附件记录！</div> -->
            </div>
          </van-tab>
          <van-tab title="收款约定">
            <div class="item">
              <van-list :finished="finished" finished-text="没有更多了"  @load="getContPayAgreeList" v-if="contPayAgreeList.length > 0">
                <van-cell v-for="(item,index) in contPayAgreeList" :key="index">
                  <div class="flex-between" v-if="item">
                    <div style="max-width: 100%">
                      <div>
                        <span class="key"> 款项内容：</span>
                        <span class="value">{{formatHandel('contPayType',item.contPayType)}}</span>
                      </div>
                      <div>
                        <span class="key"> 付款日期：</span>
                        <span class="value">{{item.payTime}}</span>
                      </div>
                      <div>
                        <span class="key"> 付款单位：</span>
                        <span class="value">{{ item.custName }}</span>
                      </div>
                      <div>
                        <span class="key"> 收款合同方：</span>
                        <span class="value">{{ item.companyName }}</span>
                      </div>
                      <div v-if="item.entrustCustName">
                        <span class="key"> 委托付款单位：</span>
                        <span class="value">{{ item.entrustCustName }}</span>
                      </div>
                      <div>
                        <span class="key"> 付款条件：</span>
                        <span class="value">{{ item.payCondition }}</span>
                      </div>
                      <div v-if="item.contractMoney">
                        <span class="key"> 付款金额：</span>
                        <span class="value">{{ item.contractMoney }}(元)</span>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="contPayAgreeList.length == 0" />
              <!-- <div v-if="contPayAgreeList.length == 0" style="background-color: #fff;text-align:center;color:red;height:50px;line-height:50px;">暂无收款约定！</div> -->
            </div>
          </van-tab>

        </van-tabs>
      </div>
      <div v-if="activeName!='66' && activeName!='diankuan'">
        <van-grid class="grid-wrap" v-if="customer.contractStatus == '0' || customer.contractStatus == '4'" :column-num="3">
          <van-grid-item>
            <div class="flex-center" v-hasPermi="['cont:newContract:edit']" @click="edit">
              <van-icon name="edit" size="22" color="#07c160" />
              <span>修改</span>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="flex-center" v-hasPermi="['cont:newContract:remove']" @click="remove">
              <van-icon name="delete" size="22" color="#ee0a24" />
              <span>删除</span>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="flex-center" v-hasPermi="['cont:newContract:spApply']" v-if="customer.payType==1 && customer.templateType==2" @click="handleSpApply(customer)">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span>用章申请</span>
            </div>
            <div class="flex-center" v-hasPermi="['cont:newContract:yyApply']" v-if="customer.payType==1 && customer.templateType==1" @click="handleYyApply(customer)">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span>用印申请</span>
            </div>
            <div class="flex-center" v-hasPermi="['cont:newContract:dkApply']" v-if="customer.payType==2" @click="handleDkApply(customer)">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span>垫款授信申请</span>
            </div>
          </van-grid-item>
        </van-grid>
        <van-grid class="grid-wrap" v-if="customer.contractStatus=='5' || customer.contractStatus=='6'" :column-num="2">
          <van-grid-item>
            <!-- <div class="flex-center" v-hasPermi="['cont:newContract:yzVerify']" v-if="customer.contractStatus=='5' && customer.contractStatus != '30'" @click="handleConfirm(customer)">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span>用章确认</span>
            </div> -->
            <!-- <div class="flex-center" v-hasPermi="['cont:newContract:placeFile']" v-if="customer.contractStatus=='6'">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span @click="handleSign(customer)">签署归档</span>
            </div> -->
          </van-grid-item>
          <van-grid-item>
            <div class="flex-center" v-hasPermi="['cont:newContract:zfVerify']" v-if="(customer.contractStatus=='5' || customer.contractStatus=='6' || customer.contractStatus=='10') && customer.contractStatus != '30'" @click="handleNullify(customer)">
              <van-icon name="failure" size="22" color="#ff976a" />
              <span>作废</span>
            </div>
          </van-grid-item>
        </van-grid>
        <van-grid class="grid-wrap" v-if="customer.contractStatus=='4'" :column-num="1">
          <van-grid-item>
            <div class="flex-center" v-hasPermi="['cont:newContract:zfVerify']" @click="handleNullify(customer)">
              <van-icon name="failure" size="22" color="#ff976a" />
              <span>作废</span>
            </div>
          </van-grid-item>
        </van-grid>
        <van-grid class="grid-wrap" v-if="activeName=='0' && active == '4' && customer.contractStatus == 7" :column-num="2">
          <van-grid-item>
            <div class="flex-center" @click="addFile(customer)">
              <van-icon name="add-o" size="22" color="#1989fa" />
              <span>新增附件</span>
            </div>
          </van-grid-item>
          <van-grid-item />
        </van-grid>
        <van-grid class="grid-wrap" v-if="customer.contractStatus=='1' || customer.contractStatus=='3' || customer.contractStatus=='5'" :column-num="1">
          <van-grid-item>
            <div class="flex-center" @click="handleExpediting(customer)">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span>合同催审</span>
            </div>
          </van-grid-item>
        </van-grid>
        <van-grid v-if="customer.contractStatus == '7' && activeName=='0'" class="grid-wrap" :column-num="1" v-hasPermi="['cont:newContract:editExecTime']">
          <van-grid-item>
            <div class="flex-center">
              <van-icon name="edit" size="22" color="#07c160" />
              <span @click="fixZXtime(customer)">修改执行时间</span>
            </div>
          </van-grid-item>
        </van-grid>
        <van-grid class="grid-wrap" :column-num="2">
          <!-- <van-grid-item>
            <div class="flex-center">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span @click="handleAgreement(customer)">补充协议</span>
            </div>
          </van-grid-item> -->
          <van-grid-item>
            <div class="flex-center" @click="handleProject(customer)" v-if="customer.custSource == 1">
              <van-icon name="sign" size="22" color="#1989fa" />
              <span>合同项目</span>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="flex-center" v-hasPermi="['cont:newContract:editFollowUser']" @click="handleInherit(customer)">
              <van-icon name="manager-o" size="22" color="#ff976a" />
              <span>更改跟进人</span>
            </div>
          </van-grid-item>
        </van-grid>
        <!-- <van-grid class="grid-wrap" v-if="customer.contractNum.indexOf('2022') > -1 && activeName=='0' && customer.contractStatus == '7'" :column-num="1">
          <van-grid-item>
            <div class="flex-center">
              <van-icon name="edit" size="22" color="#07c160" />
              <span @click="timeLimited(customer)">业务员限时修改</span>
            </div>
          </van-grid-item>
        </van-grid> -->
      </div>

      <van-grid class="grid-wrap" v-if="(customer.contractStatus == '6' || customer.contractStatus == '10' || customer.contractStatus == '7')" :column-num="2">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:payCompany:add']" @click="handlePayer(customer)" >
            <van-icon name="newspaper-o" size="22" color="#1989fa" />
            <span>付款单位</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="customer.custSource == '2'" @click="handleExecutive(customer)">
            <van-icon name="manager-o" size="22" color="#1989fa" />
            <span>执行客户</span>
          </div>
        </van-grid-item>
      </van-grid>
      <!-- <van-grid class="grid-wrap" v-if="(customer.contractStatus == '6' || customer.contractStatus == '10' || customer.contractStatus == '7') && customer.custSource == '2'" :column-num="1">
        <van-grid-item>
          <div class="flex-center">
            <van-icon name="manager-o" size="22" color="#1989fa" />
            <span @click="handleExecutive(customer)">执行客户</span>
          </div>
        </van-grid-item>
      </van-grid> -->
      <!-- v-if="customer.payType == 1" -->
      <van-grid class="grid-wrap" v-if="activeName=='66'" :column-num="2">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:payment:add']" @click="handlePayment(customer)">
            <van-icon name="after-sale" size="22" color="#07c160" />
            <span>添加收款</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="Number(customer.contractMoney) <= 5000 && (customer.businessTypeName.indexOf('附近推') > -1 || customer.businessTypeName.indexOf('腾讯常规') > -1 || customer.businessTypeName.indexOf('搜狗') > -1)" @click="handleQrCode(customer)">
            <van-icon name="qr-invalid" size="22" color="#323233" />
            <span>二维码收款</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid class="grid-wrap" v-if="activeName=='diankuan' && (customer.channelType !== 3 || roleKey.indexOf('SYBMJCZ') > -1 || roleKey.indexOf('QDGLY') > -1)" :column-num="2">
        <van-grid-item>
          <div class="flex-center" @click="handleAdvances(customer)">
            <van-icon name="after-sale" size="22" color="#1989fa" />
            <span>添加垫款</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" @click="handleAdCopy(customer)">
            <van-icon name="notes-o" size="22" color="#1989fa" />
            <span>垫款复制</span>
          </div>
        </van-grid-item>
      </van-grid>
      <!-- <div class="link" v-if="activeName">
        <van-button v-if="activeName=='2' && customer.contractStatus != '30'" class="linkaddBtn" round block type="info" size="small"
          @click="handleConfirm(customer)" v-hasPermi="['cont:newContract:edit']">用章确认</van-button>
        <van-button v-if="activeName=='3'" class="linkaddBtn" round block type="info" size="small"
          @click="handleSign(customer)" v-hasPermi="['cont:newContract:placeFile']">签署归档</van-button>
        <van-button v-if="(activeName=='2' || activeName=='3') && customer.contractStatus != '30'" class="linkaddBtn" round block type="warning" size="small"
          @click="handleNullify(customer)" v-hasPermi="['cont:newContract:edit']">作废</van-button>
      </div>
      <div class="link" v-else>
        <van-button class="linkaddBtn" size="small" round block type="info" v-if="customer.contractStatus==0 && customer.payType==1 && customer.templateType==2"
          @click="handleSpApply(customer)" v-preventReClick v-hasPermi="['cont:newContract:spApply']">用章申请</van-button>
        <van-button class="linkaddBtn" size="small" round block type="info" v-if="customer.contractStatus==0 && customer.payType==2"
          @click="handleDkApply(customer)" v-preventReClick v-hasPermi="['cont:newContract:spApply']">垫款申请</van-button>
      </div> -->
    </div>
    <van-dialog v-model="qrCodeFormShow" title="新增二维码收款" width="95%" style="height:50%" class="nullifyClue" :beforeClose="qrCodeBeforeClose" show-cancel-button>
      <van-form ref="qrCodeForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="qrCodeForm.custName" label="客户名称" type="text" placeholder="请输入客户名称" :rules="[{ required: true }]" required disabled />
          <van-field v-model="qrCodeForm.contactName" label="联系人" type="text" placeholder="请输入联系人" :rules="[{ required: true }]" required />
          <van-field v-model="qrCodeForm.mobile" label="联系人手机号" type="number" placeholder="请输入联系人手机号" :rules="[{ required: true }]" required />
          <van-field v-model="qrCodeForm.payMoney" label="收款金额(元)" type="number" placeholder="请输入收款金额" :rules="[{ required: true }]" required />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <van-dialog v-model="nullifyFormShow" title="合同作废" width="95%" style="height:50%" class="nullifyClue" :beforeClose="nullifyBeforeClose" show-cancel-button>
      <van-form ref="nullifyForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-cell title="作废状态：" required>
            <template>
              <van-radio-group v-model="nullifyForm.contractStatus" direction="horizontal">
                <van-radio name="31" clickable @click="nullifyForm.contractStatus = '31'">作废重签</van-radio>
                <van-radio name="30" clickable @click="nullifyForm.contractStatus = '30'">作废</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-model="nullifyForm.nullifyReason"
            autosize required
            label="作废原因"
            placeholder="请输入作废原因"
            type="textarea"
            show-word-limit
            :rules="[{ required: true }]"/>
        </van-cell-group>
      </van-form>
    </van-dialog>
    <van-dialog v-model="fileFormShow" :title="isChange?'附件变动':'签署归档'" width="95%" style="height:80%" class="fileClue" :beforeClose="fileBeforeClose" show-cancel-button>
      <van-form ref="fileForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <!-- <van-field v-model="fileForm.title" label="附件标题" placeholder="请输入附件标题" :rules="[{ required: true }]" required/> -->
          <van-field v-if="!isChange" v-model="fileForm.amount" label="合同金额(元)" placeholder="请输入合同金额" type="digit" maxlength="8" />
          <span class="tooltip" v-if="!isChange">确认最终签约金额 ，如果金额有修改的同步到合同金额</span>
          <van-field v-if="isChange" v-model="fileForm.fileTypeName" label="附件类型" placeholder="请选择附件类型" readonly clickable  @click="showPicker('fileType')" :rules="[{ required: true }]" required />
          <van-field v-else v-model="fileForm.fileTypeName" label="附件类型" disabled required/>
          <van-field
            v-model="fileForm.fileDesc"
            rows="2"
            autosize
            label="附件描述"
            placeholder="请输入附件描述"
            type="textarea"
            show-word-limit
          />
          <!-- <van-field v-model="fileForm.fileName" label="其他附件" placeholder="需要上传的PDF文件" readonly :rules="[{ required: true }]" required>
            <template #button>
              <van-uploader :after-read="uploadContractPictureFiles" :before-read="beforeRead" accept="application/pdf">
                <van-button icon="plus" type="info" size="mini">上传附件</van-button>
              </van-uploader>
            </template>
          </van-field> -->
          <van-field v-model="fileForm.url" label="其他附件" placeholder="需要上传的PDF文件" readonly :rules="[{ required: true }]" required >
            <template #button>
              <van-uploader :after-read="uploadContractPictureFiles" :before-read="beforeRead" :max-size="10000 * 1024" @oversize="onOversize" accept="application/pdf,.doc,.docx,">
                <van-button icon="plus" type="info" size="mini">上传附件</van-button>
              </van-uploader>
            </template>
          </van-field>
          <div style="padding: 10px 20px 0 0;text-align: right;font-size: 14px" >
            <a v-if="fileForm.url" :href="fileForm.url" @click="downloadUrlFile(fileForm.url,fileForm.title + '附件')">{{fileForm.fileName}}    查看附件</a>
          </div>
          <!-- <van-field v-if="fileForm.url" v-model="fileForm.fileName" label="附件详情" readonly @click="downloadUrlFile(fileForm.url,fileForm.title + '附件')" /> -->
      </van-form>
    </van-dialog>
    <van-dialog v-model="statusShow" title="审批详情" width="95%" style="height:60%;overflow-y:auto" class="auditDetails" :show-confirm-button="false" :closeOnClickOverlay="true">
      <!-- <van-steps direction="vertical" :active="0">
        <van-step v-for="(item,index) in viewStatusList" :key="index">
          <h4>审批用户：{{item.userName}}</h4>
          <h4>审批状态：{{item.spStatus == 2?'已通过':'审批中'}}</h4>
          <p v-if="item.spTime">审批时间：{{item.spTime}}</p>
        </van-step>
      </van-steps> -->
      <van-cell-group inset>
        <van-cell v-for="(item,index) in viewStatusList" :key="index" :title="item.userName">
          <template>
            <van-tag v-if="activeName" :type="item.spStatus == 2?'success':'warning'">{{item.spStatus == 2?'已通过':'审批中'}}</van-tag>
            <van-tag v-else :type="item.spStatus == 3?'danger':'warning'">{{item.spStatus == 3?'驳回':'审批中'}}</van-tag>
          </template>
          <template #label>
            <div v-if="item.spTime">审批时间：{{item.spTime}}</div>
            <div v-if="item.spComment">审批备注：{{item.spComment}}</div>
          </template>
        </van-cell>
      </van-cell-group>
      <empty v-if="viewStatusList.length == 0" />
    </van-dialog>
    <van-dialog v-model="inheritFormShow" title="更改跟进人【我的合同】" width="95%" style="height:50%" class="nullifyClue" :beforeClose="inheritBeforeClose" show-cancel-button>
      <van-form ref="inheritForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field readonly clickable v-model="inheritForm.deptName" label="我方签约部门" @click="showCascader('dept')" :rules="[{ required: true }]" placeholder="请选择我方签约部门" required />
          <van-field readonly clickable v-model="inheritForm.userName" label="我方签约人"  @click="inheritForm.deptId?showPicker('userName'):''" placeholder="请先选择我方签约部门再选择我方签约人" :rules="[{ required: true }]" required />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" :field-names="tree.fieldNames" @change="treeChange" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <!-- <dialog-payment :show='paymentFormShow' :isAdd="true" :contractId="customer.contractId" @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose'></dialog-payment> -->
    <van-dialog v-model="showAdvances" class="cust" width="95%" style="height: 80%" title="复制历史垫款数据" :showConfirmButton = 'false' :close-on-click-overlay="true">
      <!-- <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入客户名称搜索"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search> -->
      <van-list class="van-list" v-model="advancesLoading" style="height: 80%" :finished="advancesFinished" finished-text="没有更多了" @load="advancesOnLoad" v-if="advancesList.length > 0">
        <van-cell v-for="(item,index) in advancesList" :key="index">
          <div class="flex-between">
            <div style="flex: 9">
              <div class="custName-wrap"> <div class="custName"> {{ item.contractName }} </div> </div>
              <div style="color: #666">本次垫款(元)：{{item.payMoney}}</div>
              <div style="color: #666">申请时间(元)：{{item.createTime}}</div>
            </div>
            <van-button style="flex: 1" size="small" type="warning" @click="selectAdvances(item)">复制</van-button>
          </div>
        </van-cell>
      </van-list>
      <Empty v-if="advancesList.length == 0" />
    </van-dialog>
    <dialog-advances :show='advancesFormShow' :isAdd="true" :modifyObj="advancesForm" :contractId="customer.contractId" @handleAdvancesCancel='handleAdvancesCancel' @beforeClose='addAdvancesBeforeClose'></dialog-advances>

    <!-- 项目返点信息 -->
    <van-dialog v-model="projectPointVisible" title="项目名称返点" width="95%" style="height:80%;"  :close-on-click-overlay="true" :showConfirmButton = 'false'>
      <van-list v-if="projectPointList.length > 0" style="margin-top: 10px">
        <van-cell v-for="(item,index) in projectPointList" :key="index">
          <div class="flex-between" v-if="item" style="align-items: flex-start">
            <div>
              <div>
                <span class="key"> 返点百分比值(%)：</span>
                <span class="value">{{ item.percentage }}%</span>
              </div>
              <div>
                <span class="key"> 返点消耗(元)：</span>
                <span class="value" style="color: #ee0a24;">{{ item.useMoney }}(元)</span>
              </div>
              <div style="padding-left:70px;text-indent:-70px;">
                <span class="key"> 执行时间：</span>
                <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
      <Empty v-if="projectPointList.length == 0"></Empty>
    </van-dialog>

    <project-operations :contractId="customer.contractId" :setProjectVisible="projectVisible" @closeProject="closeProject"></project-operations>

    <!-- 修改执行时间 -->
    <van-dialog v-model="zxFormShow" title="修改执行时间" width="95%" style="height:50%" class="nullifyClue" :beforeClose="zxBeforeClose" show-cancel-button>
      <van-form ref="zxForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="zxForm.executionTime" readonly clickable name="calendar" label="合同执行时间" placeholder="点击选择合同执行时间" @click="showCalendar" required />
          <van-field v-model="zxForm.remark"
            autosize
            required
            label="更改原因"
            placeholder="请输入执行时间更改原因"
            type="textarea"
            rows="5"
            show-word-limit
            :rules="[{ required: true }]"/>
        </van-cell-group>
      </van-form>
    </van-dialog>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="dateConfirm" />
  </div>
</template>

<script>

import newContract from '@/api/cont/newContract'
import payment from '@/api/cont/payment'
import { getDicts } from '@/api/system/dict/data'
import { Dialog, Toast, Cascader, Divider } from 'vant'
import Empty from '@/components/common/Empty'
// import DialogPayment from '../components/DialogPayment.vue'
import DialogAdvances from '../components/DialogAdvances.vue'
import ProjectOperations from '@/views/cont/components/ProjectOperations.vue'
import { CascaderTreeSelect } from '@/api/admi/dept'
import { selectDeptIdByUserList } from '@/api/admi/user'
import LogExamine from '@/components/LogExamine.vue'
export default {
  components: {
    Empty,
    ProjectOperations,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Divider.name]: Divider,
    vanCascader: Cascader,
    // DialogPayment,
    DialogAdvances,
    LogExamine
  },
  data() {
    return {
      loadingShow: false,
      active: 0,
      activeName: '',
      contractImg: require('../../../assets/images/desktop/contractName.png'),
      contractId: '',
      finished: true,
      isVendite: false, // 是否是 销售/数字技术类
      options: {
        mediaTypeOptions: [],
        cooperationPolicyOptions: [],
        operationModeOptions: [],
        invoicingMethodOptions: [],
        invoiceTypeOptions: [],
        signedMainTypeOptions: [],
        templateTypeOptions: [],
        frameTypeOptions: [],
        custSourceOptions: [],
        payTypeOptions: [],
        contPayTypeOptions: [],
        fileTypeOptions: [],
        creditCycleTypeOptions: [],
        contractStatusOptions: [],
        executionStatusOptions: [{ dictLabel: '未执行', dictValue: 0 }, { dictLabel: '即将到期', dictValue: 1 }, { dictLabel: '执行中', dictValue: 2 },
          { dictLabel: '合同过期', dictValue: 3 }, { dictLabel: '合同完成', dictValue: 4 }, { dictLabel: '已续签', dictValue: 5 }, { dictLabel: '作废', dictValue: 6 }]
      },
      typeArr: ['warning', 'warning', 'primary', 'danger', 'success', 'primary', 'danger'],
      // 合同附件
      contractFileList: [],
      // 收款约定
      contPayAgreeList: [],
      // 合同日志
      contractLogList: [],
      // 返点
      pointList: [],
      pdfSrc: '', // pdf文件地址
      numPages: 0,
      customer: {},
      queryContFileParams: {
        contractId: null
      },
      nullifyFormShow: false,
      nullifyForm: {
        nullifyReason: '',
        contractStatus: '31',
        contractId: ''
      },
      fileFormShow: false,
      fileForm: {
        contractId: '',
        title: '',
        fileType: '4',
        fileTypeName: '签署归档',
        url: '',
        amount: '',
        fileDesc: '',
        contractStatus: 7
      },
      payerFormShow: false,
      payerList: [],
      paymentFormShow: false,
      paymentForm: {},
      statusShow: false,
      viewStatusList: [],
      isChange: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      showAdvances: false,
      advancesLoading: false,
      advancesFinished: false,
      advancesList: [],
      advancesTotal: 0,
      advancesQuery: {
        contractId: '',
        pageNum: 1,
        pageSize: 10,
        // checkStatus: 0,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      advancesForm: {},
      advancesFormShow: false,
      qrCodeFormShow: false,
      qrCodeForm: {
        contractId: '',
        payMoney: '',
        custName: '',
        payOrderName: '',
        contactName: '',
        mobile: ''
      },
      inheritFormShow: false,
      inheritForm: {
        ids: [],
        deptId: null,
        deptName: null,
        userId: null,
        userName: ''
      },
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      deptTreeList: [],
      deptUserList: [],

      // 项目名称相关
      projectList: [],
      projectPointVisible: false,
      projectPointList: [],

      projectVisible: false,

      zxFormShow: false,
      zxForm: {
        contractId: null,
        startTime: null,
        endTime: null,
        executionTime: null,
        remark: null
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2023, 0, 1),
        maxDate: new Date(2042, 11, 31),
        type: 'range',
        formKey: ''
      },
      roleKey: null
    }
  },
  async created() {
    this.roleKey = this.$store.state.user.user.roles.map(item => { return item.roleKey }).join(',')
    await this.getOptions()
    const { id, active } = this.$route.query
    this.activeName = active
    this.queryContFileParams.contractId = id
    const res = await newContract.getContract(id)
    if (res.code === 200) {
      this.loadingShow = true
      this.customer = res.data
      const name = res.data.businessTypeName.split('/')
      if (name[0] == '销售' && name[1] == '数字技术类') {
        this.isVendite = false
      } else {
        this.isVendite = true
      }
    }
    await this.getContractFileList()
    await this.getContPayAgreeList()
    // await this.getContractLogList()
    // await this.getPointList()
    await this.getProjectList()
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem('contractQuery'))) {
      sessionStorage.setItem('contractSearch', true)
    }
    // this.getCustLevelList();
    this.init()
    // this.queryListVisit();
  },
  methods: {
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getOptions() {
      // 媒介归属
      getDicts('media_type').then(res => {
        this.options.mediaTypeOptions = res.data
      })
      // 合作政策
      getDicts('cooperation_policy').then(res => {
        this.options.cooperationPolicyOptions = res.data
      })
      // 运营方式
      getDicts('operation_mode').then(res => {
        this.options.operationModeOptions = res.data
      })
      // 开票方式
      getDicts('Invoicing_method').then(res => {
        this.options.invoicingMethodOptions = res.data
      })
      // 发票类型
      getDicts('Invoice_type').then(res => {
        this.options.invoiceTypeOptions = res.data
      })
      // 我方主体地址
      getDicts('signed_main_type').then(res => {
        this.options.signedMainTypeOptions = res.data
      })
      // 合同模板
      getDicts('template_type').then(res => {
        this.options.templateTypeOptions = res.data
      })
      // 框架类型
      getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      // 付款类型
      getDicts('cont_pay_type').then(res => {
        this.options.contPayTypeOptions = res.data
      })
      // 附件类型
      getDicts('file_type').then(res => {
        this.options.fileTypeOptions = res.data
      })
      // 授信账期类型
      getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
      // 合同状态
      getDicts('contract_status').then(res => {
        this.options.contractStatusOptions = res.data
      })
    },
    async init() {
      // 修改主体框架标题
      document.title = 'CONT-合同详情'
    },
    // 获取合同附件列表
    async getContractFileList() {
      newContract.listContractFile(this.queryContFileParams).then(response => {
        this.contractFileList = response.rows
      })
    },
    // 获取收款约定列表
    async getContPayAgreeList() {
      newContract.listPayAgree(this.queryContFileParams).then(response => {
        this.contPayAgreeList = response.rows
      })
    },
    // 获取合同操作记录
    async getContractLogList() {
      const params = {
        contractId: this.queryContFileParams.contractId,
        bigType: 1
      }
      newContract.listContractLog(params).then(response => {
        this.contractLogList = response.rows
      })
    },
    tabClick(name, title) {
      if (name === 1) {
        this.getContractLogList()
      }
    },
    // 获取返点列表
    async getPointList() {
      const params = {
        contractId: this.queryContFileParams.contractId
      }
      newContract.getRebateList(params).then(response => {
        this.pointList = response.rows
      })
    },
    // 获取合同项目信息
    async getProjectList() {
      newContract.listProjectPercentage({ bussType: 1, bussId: this.customer.contractId }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
        }
      })
    },
    // 项目返点信息
    pointDetail(row) {
      newContract.getRebateList({ contractId: this.customer.contractId, projectId: row.projectId }).then(res => {
        this.projectPointList = res.rows
        this.projectPointVisible = true
      })
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url2, true)
      xhr.responseType = 'blob'
      // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }
      xhr.send()
    },
    edit() {
      this.$router.push('/cont/contract/add?contractId=' + this.customer.contractId)
    },
    timeLimited() {
      this.$router.push('/cont/approve/timeLimited?contractId=' + this.customer.contractId)
    },
    handleAgreement(row) {
      this.$router.push({
        path: '/cont/payment/agreementList',
        query: { id: row.contractId }
      })
    },
    async remove() {
      Dialog.confirm({
        message: '是否确认删除此条数据'
      })
        .then(() => {
          this.delete()
        })
        .catch(() => {
        // on cancel
        })
    },
    async delete() {
      const res = await newContract.deleteContract(this.customer.contractId)
      if (res.code === 200) {
        await Toast.success('成功删除!')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    },

    // 合同项目
    handleProject(row) {
      this.projectVisible = true
    },
    // 关闭
    closeProject() {
      this.projectVisible = false
    },
    // 用章申请
    async handleSpApply(row) {
      // console.log(row)
      // console.log(this.contractFileList)

      if (this.contractFileList.length == 0) {
        Toast.fail('请在修改中添加合同附件信息!')
        return
      }
      if (row.isSupCont !== 2 && row.isSupCont !== 3) {
        if ((row.businessTypeName.indexOf('数字技术类') === -1 && row.businessTypeName.indexOf('品牌推广') === -1) && row.contReturnPointList.length == 0) {
          Toast.fail('请先填写合同项目信息及项目返点')
          return
        }
      }
      Dialog.confirm({
        message: '是否进行用章申请'
      })
        .then(() => {
          this.spApply(row.contractId)
        })
        .catch(() => {
        // on cancel
        })
    },
    async spApply(val) {
      const res = await newContract.spApply({ contractId: val })
      if (res.code === 200) {
        await Toast.success('用章申请成功!')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    },
    // 垫款授信申请
    handleDkApply(row) {
      if (this.contractFileList.length == 0) {
        Toast.fail('请在修改中添加合同附件信息!')
        return
      }
      if (row.isSupCont !== 2 && row.isSupCont !== 3) {
        if ((row.businessTypeName.indexOf('数字技术类') === -1 && row.businessTypeName.indexOf('品牌推广') === -1) && row.contReturnPointList.length == 0) {
          Toast.fail('请先填写合同项目信息及项目返点')
          return
        }
      }
      Dialog.confirm({
        message: '是否进行垫款授信申请'
      })
        .then(() => {
          this.dkApply(row.contractId)
        })
        .catch(() => {
        // on cancel
        })
    },
    async dkApply(val) {
      const res = await newContract.dkApply({ contractId: val })
      if (res.code === 200) {
        await Toast.success('垫款授信申请成功!')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    },
    // 作废
    handleNullify(row) {
      this.contractId = row.contractId
      this.nullifyFormShow = true
    },
    async nullifyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.nullifyForm.validate()
          this.nullifyForm.contractId = this.contractId
          await newContract.updateContract(this.nullifyForm)
          await this.reset()
            .then(() => {
              Toast.success('作废成功')
              this.nullifyFormShow = false
              setTimeout(() => {
                if (this.nullifyForm.contractStatus == '31') {
                  this.$router.push({
                    path: '/cont/contract/add',
                    query: {
                      contractId: this.contractId,
                      isZfcq: true
                    }
                  })
                  return
                }
                this.$router.go(-1)
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.nullifyFormShow = false
      }
    },
    // 清空表单
    async reset() {
      this.nullifyForm = {
        nullifyReason: '',
        contractStatus: '31',
        contractId: ''
      }
      this.fileForm = {
        contractId: '',
        title: '',
        fileType: '4',
        fileTypeName: '签署归档',
        url: '',
        amount: '',
        fileDesc: '',
        contractStatus: 7
      }
    },
    // 用章确认
    handleConfirm(row) {
      Dialog.confirm({
        message: '是否用章确认此条数据'
      })
        .then(() => {
          this.confirm(row.contractId)
        })
        .catch(() => {
        // on cancel
        })
    },
    async confirm(val) {
      const res = await newContract.updateContract({ contractId: val, contractStatus: 6 })
      if (res.code == 200) {
        await Toast.success('用章确认成功!')
        setTimeout(() => {
          // this.$router.go(-1)
          // this.$router.push({
          //   path: '/daiban',
          //   query: { type: 1 }
          // })
          this.afterConfirm()
        }, 500)
      }
    },
    async afterConfirm() {
      const response = await newContract.listContract({ contractStatus: 5 })
      if (response.rows.length > 0) {
        this.queryContFileParams.contractId = response.rows[0].contractId
        const res = await newContract.getContract(response.rows[0].contractId)
        if (res.code === 200) {
          this.loadingShow = true
          this.customer = res.data
          const name = res.data.businessTypeName.split('/')
          if (name[0] == '销售' && name[1] == '数字技术类') {
            this.isVendite = false
          } else {
            this.isVendite = true
          }
        }
        await this.getContractFileList()
        await this.getContPayAgreeList()
        await this.getContractLogList()
        // await this.getPointList()
        await this.getProjectList()
      } else {
        this.$router.go(-1)
      }
    },
    // 用印申请
    handleYyApply(row) {
      if (this.contractFileList.length == 0) {
        Toast.fail('请在修改中添加合同附件信息!')
        return
      }
      if (row.isSupCont !== 2 && row.isSupCont !== 3) {
        if ((row.businessTypeName.indexOf('数字技术类') === -1 && row.businessTypeName.indexOf('品牌推广') === -1) && row.contReturnPointList.length == 0) {
          Toast.fail('请先填写合同项目信息及项目返点')
          return
        }
      }
      Dialog.confirm({
        message: '是否进行用印申请'
      })
        .then(() => {
          this.yyApply(row.contractId)
        })
        .catch(() => {
        // on cancel
        })
    },
    async yyApply(val) {
      const res = await newContract.yyApply({ contractId: val })
      if (res.code == 200) {
        await Toast.success('用印申请成功!')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    },
    // 签署归档
    handleSign(row) {
      this.contractId = row.contractId
      this.fileForm.amount = row.contractMoney
      this.fileFormShow = true
    },
    // 付款单位
    handlePayer(row) {
      this.$router.push({
        path: '/cont/payment/payerList',
        query: {
          contractId: row.contractId
        }
      })
    },
    // 执行客户
    handleExecutive(row) {
      this.$router.push({
        path: '/cont/payment/executiveList',
        query: {
          contractId: row.contractId,
          channelType: row.channelType
        }
      })
    },
    handleAddContractCancel() {
      this.paymentFormShow = false
    },
    // 添加合同
    async addContractBeforeClose() {
      this.paymentFormShow = false
      // await this.queryCustList()
    },
    // 打款充值
    handlePayment(row) {
      this.contractId = row.contractId
      this.paymentFormShow = true
    },
    handleQrCode(row) {
      this.contractId = row.contractId
      this.qrCodeForm.contractId = row.contractId
      this.qrCodeForm.mobile = row.signedUserMobile
      this.qrCodeForm.contactName = row.signedUser
      this.qrCodeForm.custName = row.custName
      this.qrCodeForm.payMoney = row.contractMoney
      if (row.businessTypeName.indexOf('附近推') > -1) {
        this.qrCodeForm.payOrderName = '腾讯附近推广告'
      } else if (row.businessTypeName.indexOf('腾讯常规') > -1) {
        this.qrCodeForm.payOrderName = '腾讯常规广告'
      } else if (row.businessTypeName.indexOf('搜狗') > -1) {
        this.qrCodeForm.payOrderName = '搜狗广告'
      }
      this.qrCodeFormShow = true
    },
    async qrCodeBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.qrCodeForm.validate()
          await payment.addQrCode(this.qrCodeForm)
            .then((res) => {
              Toast.success('新增成功')
              this.qrCodeFormShow = false
              setTimeout(() => {
                this.$router.push({
                  path: '/cont/payment/qrCodeDetail',
                  query: { id: res.data.payOrderId }
                })
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.qrCodeFormShow = false
      }
    },
    // 垫款复制
    async handleAdCopy(row) {
      this.advancesQuery.contractId = row.contractId
      await this.handleAdvancesList()
      this.showAdvances = true
    },
    async handleAdvancesList() {
      this.advancesLoading = true
      const res = await payment.listAdvances(this.advancesQuery)
      if (res.code === 200) {
        this.advancesList = this.advancesList.concat(...res.rows)
        this.advancesQuery.pageNum += 1
        this.advancesTotal = res.total
        this.advancesFinished = this.advancesList.length >= res.total
        this.advancesLoading = false
      }
    },
    advancesOnLoad() {
      this.handleAdvancesList()
    },
    selectAdvances(row) {
      this.showAdvances = false
      this.advancesForm = row
      this.advancesForm.delayedCommitmentFile = null
      this.advancesForm.rechargeImg = null
      this.advancesForm.spNo = null
      this.advancesFormShow = true
    },
    // 添加垫款
    handleAdvances(row) {
      this.contractId = row.contractId
      this.advancesFormShow = true
    },
    handleAdvancesCancel() {
      this.advancesFormShow = false
    },
    addAdvancesBeforeClose() {
      this.advancesFormShow = false
    },
    // 催审
    handleExpediting(row) {
      Dialog.confirm({
        message: '是否发送催审消息？'
      })
        .then(() => {
          const obj = { contractId: row.contractId, type: this.activeName - 1 }
          newContract.contUrge(obj.contractId, obj.type)
            .then(res => {
              if (res.code === 200) {
                Toast.success('催审成功!')
              }
            })
        })
        .catch(() => {
        // on cancel
        })
    },
    // 修改合同执行时间
    fixZXtime(row) {
      this.zxForm.contractId = row.contractId
      this.zxForm.startTime = row.startTime
      this.zxForm.endTime = row.endTime
      this.zxForm.executionTime = `${row.startTime} 至 ${row.endTime}`
      this.zxFormShow = true
    },
    async zxBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.zxForm.validate()
          await newContract.editExecTime(this.zxForm)
            .then((res) => {
              if (res.code == 200) {
                Toast.success('修改成功')
                this.zxFormShow = false
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
      }
    },
    showCalendar() {
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      const [start, end] = date
      this.zxForm.startTime = this.formatDate(start)
      this.zxForm.endTime = this.formatDate(end)
      this.zxForm.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    // 修改合同附件
    modifyFile(row) {
      console.log(row)
      this.isChange = true
      this.fileForm = row
      this.fileForm.fileTypeName = this.formatHandel('fileType', this.fileForm.fileType)
      this.fileFormShow = true
    },
    // 新增合同附件
    addFile(row) {
      this.contractId = row.contractId
      this.isChange = true
      this.fileForm = {
        contractId: '',
        title: '',
        fileType: '',
        fileTypeName: '',
        url: '',
        amount: '',
        fileDesc: ''
      }
      this.fileFormShow = true
    },
    showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'userName') {
        // 选择人员
        selectDeptIdByUserList(this.inheritForm.deptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          // this.picker.loading = false
        })
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      }
      this.picker.loading = false
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey === 'userName') {
        this.inheritForm.userName = this.deptUserList[key].nickName
        this.inheritForm.userId = this.deptUserList[key].userId
      } else {
        this.fileForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.fileForm[name] = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    deleteFile(row) {
      Dialog.confirm({
        message: '是否确认删除此条附件数据'
      })
        .then(() => {
          this.deleteFi(row.id)
        })
        .catch(() => {
        // on cancel
        })
    },
    async deleteFi(id) {
      const res = await newContract.deleteContractFile(id)
      if (res.code === 200) {
        await Toast.success('删除成功')
        setTimeout(() => {
          this.getContractFileList()
        }, 500)
      }
    },
    async fileBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.fileForm.validate()
          if (this.isChange) {
            if (this.fileForm.id) {
              const res = await newContract.updateContractFile(this.fileForm)
              if (res.code === 200) {
                await Toast.success('修改成功')
                this.fileFormShow = false
                setTimeout(() => {
                  this.getContractFileList()
                }, 500)
              }
            } else {
              this.fileForm.contractId = this.contractId
              const res = await newContract.addContractFile2(this.fileForm)
              if (res.code === 200) {
                await Toast.success('新增成功')
                this.fileFormShow = false
                setTimeout(() => {
                  this.getContractFileList()
                }, 500)
              }
            }
          } else {
            this.fileForm.contractId = this.contractId
            await newContract.placeFile(this.fileForm)
            await this.reset()
              .then(() => {
                Toast.success('归档成功')
                this.fileFormShow = false
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              }).catch(() => {})
            done()
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.fileFormShow = false
      }
    },
    // 返回布尔值
    beforeRead(file) {
      // console.log(file)
      const fileArr = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
      if (!fileArr.some((item) => { return file.type === item })) {
        Toast('请上传格式为 pdf/word 的文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10M')
    },
    async uploadContractPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await newContract.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.fileForm.fileName = file.file.name
            this.fileForm.url = res.url
            Toast.success(res.msg)
          } else {
            Toast.fail('res.msg')
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    // 保存附件
    // saveFile() {
    //   this.$refs.fileForm.validate(valid => {
    //     if (valid) {
    //       this.fileForm.contractId = this.contractId
    //       placeFile(this.fileForm).then(response => {
    //         this.msgSuccess('归档成功')
    //         this.fileVisible = false
    //         this.getList()
    //       })
    //     }
    //   })
    // },

    // 查看审批详情
    async viewStatus() {
      const res = await newContract.listVerify({ spNo: this.customer.spNo })
      if (res.code === 200) {
        this.viewStatusList = res.rows
        this.statusShow = true
      }
    },
    handleInherit(row) {
      this.inheritForm.ids = []
      this.inheritForm.ids.push(row.contractId)
      this.inheritFormShow = true
    },
    // 打开联级选择框
    async showCascader(val) {
      if (val === 'dept' || val === 'infoDept') {
        if (this.deptTreeList.length == 0) {
          await CascaderTreeSelect().then((response) => {
            this.deptTreeList = response.data
          })
        }
        this.tree = {
          type: val,
          title: '请选择部门',
          typeTree: true,
          treeList: this.deptTreeList,
          fieldNames: {}
        }
      }
    },
    treeChange(obj) {
      if (this.tree.type === 'dept') {
        this.inheritForm.deptId = obj.value
        this.inheritForm.deptName = obj.selectedOptions.map((option) => option.text).join('/')
      }
    },
    onFinishTree() {

    },
    async inheritBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.inheritForm.validate()
          await newContract.batchInherit(this.inheritForm)
            .then((res) => {
              if (res.code == 200) {
                Toast.success('更改成功')
                this.inheritFormShow = false
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.qrCodeFormShow = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");
.van-list{
  padding-top: 0;
}
.bigMoney{
  margin-left: 20px;
  color: #409EFF;
}
.approval-status{
  background-color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .detail_span{
    font-size: 16px;
    flex: 1;
  }
  // span{
  //   font-size: 16px;
  // }
}
.title_des{
  margin-left: 60px !important;
}
.van-tabs {
  margin-top: 20px;
  border-top: #bbb solid 2px;
}
.gd_box{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.title{
  /deep/.van-tag{
    width: auto;
  }
}
.van-list{
  padding-bottom: 0;
}
.auditDetails /deep/.van-cell__value{
  -webkit-box-flex: 0.25;
  -webkit-flex: 0.25;
  flex: 0.25;
}
.auditDetails /deep/.van-dialog__content {
  height: 68%;
}
.nullifyClue /deep/.van-dialog__content {
  height: 68%;
}
.nullifyClue{
  .van-cell__value {
    min-width: 67%; // 可根据自己需求设定值
    text-align: left;
  }
}
.fileClue /deep/.van-dialog__content {
  height: 80%;
}
/deep/.van-step__circle{
  background-color: #969799;
}
/deep/.van-step__line{
  background-color: #ebedf0;
}
.tooltip{
  color: #999;
  font-size: 16px;
  margin-left: 30px;
}
.item{
  /deep/.van-tag{
    margin-left: 10px;
  }
}
.contLogSp{
  display: flex;
  align-items: center;
  justify-content: space-between;
  div{
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-left: 5px;
  }
}
.cust /deep/.van-dialog__content {
  height: 88%;
  overflow: scroll;
}
.cust /deep/.van-dialog__footer{
  display: none;
}
</style>
